import React, { useState } from 'react';
import { Card, CardContent } from './ui/Card';
import { Input } from './ui/Input';
import { Button } from './ui/Button';
import { Calculator, ArrowRight } from 'lucide-react';
export function ROICalculator() {
  const [sends, setSends] = useState(50000);
  const [openRate, setOpenRate] = useState(20);
  const [aov, setAov] = useState(85);
  // Simple calculation logic for demo purposes
  // Assuming 2% click rate from opens, 3% conversion from clicks
  // Flowsense improves open rate by ~47% (based on stats)
  const currentRevenue = sends * (openRate / 100) * 0.02 * 0.03 * aov;
  const improvedOpenRate = openRate * 1.47;
  const projectedRevenue = sends * (improvedOpenRate / 100) * 0.02 * 0.03 * aov;
  const increase = projectedRevenue - currentRevenue;
  return <div className="bg-gray-900 rounded-2xl overflow-hidden shadow-2xl" data-id="element-156">
      <div className="grid lg:grid-cols-2 gap-0" data-id="element-157">
        <div className="p-8 lg:p-12" data-id="element-158">
          <div className="flex items-center space-x-3 mb-6" data-id="element-159">
            <div className="p-2 bg-gray-800 rounded-lg" data-id="element-160">
              <Calculator className="h-6 w-6 text-white" data-id="element-161" />
            </div>
            <h3 className="text-2xl font-bold text-white" data-id="element-162">
              Calculate Your Potential ROI
            </h3>
          </div>
          <p className="text-gray-400 mb-8" data-id="element-163">
            See how much more revenue you could be generating with AI-optimized
            flows.
          </p>

          <div className="space-y-6" data-id="element-164">
            <div data-id="element-165">
              <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-166">
                Monthly Email Sends
              </label>
              <Input type="number" value={sends} onChange={e => setSends(Number(e.target.value))} className="bg-gray-800 border-gray-700 text-gray-900 placeholder-gray-400 focus:ring-primary-400" data-id="element-167" />
            </div>
            <div data-id="element-168">
              <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-169">
                Current Open Rate (%)
              </label>
              <Input type="number" value={openRate} onChange={e => setOpenRate(Number(e.target.value))} className="bg-gray-800 border-gray-700 text-gray-900 placeholder-gray-400 focus:ring-primary-400" data-id="element-170" />
            </div>
            <div data-id="element-171">
              <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-172">
                Average Order Value ($)
              </label>
              <Input type="number" value={aov} onChange={e => setAov(Number(e.target.value))} className="bg-gray-800 border-gray-700 text-gray-900 placeholder-gray-400 focus:ring-primary-400" data-id="element-173" />
            </div>
          </div>
        </div>

        <div className="bg-white p-8 lg:p-12 flex flex-col justify-center" data-id="element-174">
          <div className="text-center" data-id="element-175">
            <p className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2" data-id="element-176">
              Projected Monthly Revenue Increase
            </p>
            <div className="text-5xl font-bold text-success mb-2" data-id="element-177">
              +${Math.round(increase).toLocaleString()}
            </div>
            <p className="text-sm text-gray-500 mb-8" data-id="element-178">
              Based on average performance improvements
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-179">
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-180">
                <p className="text-xs text-gray-500 mb-1" data-id="element-181">Current Revenue</p>
                <p className="text-lg font-semibold text-gray-900" data-id="element-182">
                  ${Math.round(currentRevenue).toLocaleString()}
                </p>
              </div>
              <div className="bg-primary-50 p-4 rounded-lg" data-id="element-183">
                <p className="text-xs text-primary-600 mb-1" data-id="element-184">
                  Projected Revenue
                </p>
                <p className="text-lg font-bold text-primary-600" data-id="element-185">
                  ${Math.round(projectedRevenue).toLocaleString()}
                </p>
              </div>
            </div>

            <a href="../register" data-id="element-186">
              <Button size="lg" className="w-full" rightIcon={<ArrowRight className="h-4 w-4" data-id="element-188" />} data-id="element-187">
                Signup Free to Unlock
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>;
}